import React from 'react';
import Collapsible from '../Components/Collapsible';
import { EditorStringModel } from '../Types/EditorString';
import EditorString from '../Components/EditorString/EditorString';

interface FaqAccordionProps {
  systemId: string;
  title: string;
  faqItems: FaqAccordionItem[];
}

interface FaqAccordionItem {
  title?: string;
  text?: EditorStringModel;
}

const FaqAccordion = (props: FaqAccordionProps) => {
  const faqList = props.faqItems;

  return (
    <div className="[&>div:first-of-type]:border-t">
      {faqList.map((faq) => (
        <Collapsible
          className="w-full border-b border-gray-100 transition"
          key={faq.title}
          label={faq.title}
          labelClassName="h3 !text-h3-mobile lg:!text-h3 store-screen:py-3"
          labelSize="h-4 w-4"
          contentClassName="[&_.ReactCollapse--collapse[aria-hidden='false']]:pb-6 [&_.ReactCollapse--collapse]:transition-all"
        >
          <EditorString value={faq.text?.value} />
        </Collapsible>
      ))}
    </div>
  );
};

export default FaqAccordion;
